import { Component, Input } from '@angular/core';
import { ScApiService } from '@sc-ui';
import { texts } from './inline-candidate-status-dropdown.texts';

@Component({
  standalone: false,
  selector: 'app-inline-candidate-status-dropdown',
  templateUrl: './inline-candidate-status-dropdown.component.html',
  styleUrls: ['./inline-candidate-status-dropdown.component.scss']
})
export class InlineCandidateStatusDropdownComponent {

  @Input()
  candidate: any;

  @Input()
  project: any;

  @Input()
  language: 'de' | 'en' = 'de';

  // status = '';

  texts = texts;

  statusNames = texts.statusNames;

  constructor(private api: ScApiService) { }


  // ngOnChanges() {

  //   if (this.candidate) {
  //     if (this.candidate.Assignment.AcceptanceStatus == 'Accepted')
  //       this.status = 'accepted';
  //     else if (this.candidate.Assignment.AcceptanceStatus == 'Rejected')
  //       this.status = 'rejected';
  //     else
  //       this.status = 'undecided';
  //   }
  // }

  getStatus()
  {
    if (this.candidate) {
      if (this.candidate.Assignment.AcceptanceStatus == 'Accepted')
        return 'accepted';
      if (this.candidate.Assignment.AcceptanceStatus == 'Rejected')
        return 'rejected';

      return 'undecided';
    }
  }

  updateStatus(s) {

    var arg = {
      AcceptanceStatus: 'None'
    };

    if (s == 'accepted')
      arg.AcceptanceStatus = 'Accepted';

    if (s == 'rejected')
      arg.AcceptanceStatus = 'Rejected';

    this.candidate.Assignment.AcceptanceStatus = arg.AcceptanceStatus;

    this.api.put('assignments/' + this.candidate.Assignment.Id, arg).subscribe(() => {

    });
  }

}
